import { AnalyticsConsumer, AnalyticsLayer } from './analyticsContext'

/**
 * This HOC should only be used to create a trackable
 * version of another component. Any logic related
 * to actually firing a tracking event belongs in the
 * component passed into this HOC.
 *
 * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
 * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
 */
const getTrackableComponent = (ComponentToTrack, contextName = null) => {
  const TrackedComponent = (props) => (
    <AnalyticsConsumer>
      {(tracker) => <ComponentToTrack {...props} trackers={tracker} />}
    </AnalyticsConsumer>
  )
  const componentName =
    ComponentToTrack.displayName ||
    ComponentToTrack.name ||
    ComponentToTrack.constructor.name

  if (!contextName) {
    TrackedComponent.displayName = `Quanta: AnalyticsConsumer(${componentName})`
    return TrackedComponent
  }

  /**
   * @deprecated Switch to `<TrackActionProvider>` and `useTrackAction`.
   * @see https://workwithopal.atlassian.net/wiki/spaces/ET/pages/3317596201/Segment+Event+Tracking
   */
  const TrackedComponentWithContext = (props) => (
    <AnalyticsLayer name={contextName}>
      <TrackedComponent {...props} />
    </AnalyticsLayer>
  )
  TrackedComponentWithContext.displayName = `Quanta: AnalyticsLayer(${TrackedComponent.displayName})`

  let outerDisplayName = componentName
  if (componentName !== contextName) {
    outerDisplayName = `${componentName} as "${contextName}"`
  }
  TrackedComponentWithContext.displayName = `Quanta: AnalyticsLayer(${outerDisplayName})`

  return TrackedComponentWithContext
}

export default getTrackableComponent
